module.exports = __webpack_public_path__ + "img/UserImage.41b1ec56.svg";